import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { ArrowRight, Home } from 'lucide-react';

// Unified top-of-page navigation: a "Back" button + a "Home" shortcut.
// Used across editor, map, public and dashboard pages for consistency.
export const NavCluster = ({ homePath = '/', testidPrefix = 'page', className = '' }) => {
  const nav = useNavigate();
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';
  return (
    <div
      className={`flex items-center bg-white rounded-md overflow-hidden border border-slate-200 shadow-sm ${className}`}
      data-testid={`${testidPrefix}-nav-cluster`}
    >
      <Button
        size="sm"
        variant="ghost"
        onClick={() => nav(-1)}
        className="rounded-none h-9 px-3 text-slate-700 hover:bg-slate-100"
        data-testid={`${testidPrefix}-back-btn`}
        title={t('common.back')}
      >
        <ArrowRight size={16} className={isEn ? 'rotate-180 mr-1' : 'ml-1'} />
        <span className="hidden sm:inline">{t('common.back')}</span>
      </Button>
      <div className="w-px h-5 bg-slate-200" />
      <Link to={homePath}>
        <Button
          size="sm"
          variant="ghost"
          className="rounded-none h-9 px-3 text-slate-700 hover:bg-slate-100"
          data-testid={`${testidPrefix}-home-btn`}
          title={t('common.home')}
        >
          <Home size={16} className={isEn ? 'mr-1' : 'ml-1'} />
          <span className="hidden sm:inline">{t('common.home')}</span>
        </Button>
      </Link>
    </div>
  );
};

export default NavCluster;
